import { css } from 'emotion';

export const channelContentRoot = (isMobile, HTML_V2, darkTheme) => css`
  .title {
    margin-bottom: 4px;
    ${!darkTheme &&
      css`
        color: #2d2d2d !important;
      `};
  }
  .description {
    margin-top: 20px;
  }
  ${isMobile &&
    HTML_V2 &&
    css`
      .title {
        padding-right: 80px;
      }
    `}
`;
